import { getDefaultBannerStyles } from 'scenes/Cms/Content/Banners/helpers'
import { AppLandingPageTheme } from './types'

export const initialAppLandingPageThemeState: AppLandingPageTheme = {
  contentBlocks: {},
  settings: {
    link_color: '#BE2227',
    background_color: '#FFFFFF',
    header_text_color: '#36424e',
    body_text_color: '#6a747f',
    ...getDefaultBannerStyles(),
    menu_category_page: {
      background_color: '#FFFFFF',
      header_text_color: '#36424E',
      body_text_color: '#6A747F',
      link_color: '#BE2227',
      product_card: {
        background_color: '#FFFFFF',
        header_text_color: '#4D4D4F',
        body_text_color: '#9FA1A4',
        border_color: '#DEDFE0',
        border_width: 1,
        border_radius: 2,
      },
      unavailable_product_card: {
        background_color: '#F3F4F4',
        header_text_color: '#BCBEC0',
        body_text_color: '#808285',
        border_color: '#DEDFE0',
      },
    },
  },
}
